/* src/app/ask-questions/ask-questions.component.scss */
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e8eff8;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.0392156863);
}
header .header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
header .header-left .header-brand {
  display: flex;
  align-items: center;
  gap: 8px;
}
header .header-left .header-brand .header-logo {
  height: 40px;
}
header .header-left .header-brand img {
  max-width: 11% !important;
}
header .header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
header .header-right .icon-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 16px;
  transition: all 0.15s;
}
.abs-area {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.abs-area .abs-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.abs-area .abs-chips-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: rgba(255, 255, 255, 0.7019607843);
  border: 1.5px solid rgba(27, 79, 216, 0.25);
  border-radius: 50px;
  font-family: Outfit, sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  color: #1b4fd8;
  cursor: pointer;
  transition: all 0.18s;
}
.abs-area .abs-chips-btn i {
  font-size: 11px;
}
.card {
  display: flex;
  justify-content: center;
  width: 100%;
}
.card .flex.flex-col {
  width: 100%;
  max-width: 320px;
  gap: 0.75rem;
}
.card .field-checkbox {
  display: flex;
  align-items: center;
  padding: 0.875rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}
.card .field-checkbox:hover {
  border-color: #6366f1;
  background: #f8fafc;
}
.card .field-checkbox label {
  margin-left: 0.75rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  flex: 1;
}
.card .field-checkbox:has(.p-radiobutton.p-highlight) {
  border-color: #6366f1;
  background: #eef2ff;
}
:host ::ng-deep .p-radiobutton {
  width: 20px;
  height: 20px;
}
:host ::ng-deep .p-radiobutton .p-radiobutton-box {
  width: 20px;
  height: 20px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  transition: all 0.2s ease;
}
:host ::ng-deep .p-radiobutton .p-radiobutton-box:hover {
  border-color: #6366f1;
}
:host ::ng-deep .p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: #6366f1;
  background: #6366f1;
}
:host ::ng-deep .p-radiobutton .p-radiobutton-box.p-highlight .p-radiobutton-icon {
  background: #fff;
  width: 8px;
  height: 8px;
}
@media (max-width: 768px) {
  .card .flex.flex-col {
    max-width: 100%;
  }
  .card .field-checkbox {
    padding: 0.75rem;
  }
  .card .field-checkbox label {
    font-size: 0.9rem;
  }
}
:host {
  display: block;
}
.main {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.welcome-banner {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  text-align: center;
}
.welcome-content {
  max-width: 700px;
}
.welcome-content h2 {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px;
}
.welcome-content h2 strong {
  color: #1b4fd8;
}
.welcome-content p {
  font-size: 13.5px;
  color: #64748b;
  margin: 0 0 20px;
}
.abs-area {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 2rem;
}
.abs-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}
.abs-chips-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: rgba(255, 255, 255, 0.7019607843);
  border: 1.5px solid rgba(27, 79, 216, 0.25);
  border-radius: 50px;
  font-family: Outfit, sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  color: #1b4fd8;
  cursor: pointer;
  transition: all 0.18s;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}
.abs-chips-btn span {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #374151;
  font-weight: 500;
}
.abs-chips-btn i {
  color: #6366f1;
}
.chat-input-wrapper {
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 1rem 1.5rem 2rem;
}
.chat-input-container {
  max-width: 850px;
  margin: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1.5px solid #E2E8F0;
  border-radius: 16px;
  padding: 10px 10px 10px 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.input-area {
  flex: 1;
}
.input-area input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 1rem;
  padding: 0.8rem;
  color: #111827;
}
.input-area input::placeholder {
  color: #9ca3af;
}
.actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.icon-btn,
.send-btn {
  width: 46px;
  height: 46px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.25s ease;
}
.icon-btn img,
.send-btn img {
  width: 22px;
  height: 22px;
}
.mic {
  background: #f3f4f6;
}
.mic:hover {
  background: #e5e7eb;
  transform: scale(1.05);
}
.call {
  background: #eef2ff;
}
.call:hover {
  background: #dbeafe;
  transform: scale(1.05);
}
.stop {
  background: #fee2e2;
}
.stop:hover {
  background: #fecaca;
  transform: scale(1.05);
}
.send-btn {
  background: #d1d5db;
  color: white;
}
.send-btn i {
  font-size: 1rem;
}
.send-btn.active {
  background:
    linear-gradient(
      135deg,
      #6366f1,
      #06b6d4);
  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.3);
}
.send-btn.active:hover {
  transform: scale(1.05);
}
.send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .welcome-content h2 {
    font-size: 2rem;
  }
  .welcome-content p {
    font-size: 0.95rem;
  }
  .abs-chips-btn {
    width: 100%;
  }
  .abs-chips-btn span {
    flex-wrap: wrap;
    justify-content: center;
  }
  .chat-input-wrapper {
    padding: 1rem;
  }
  .chat-input-container {
    gap: 0.5rem;
    padding: 0.5rem;
  }
  .icon-btn,
  .send-btn {
    width: 42px;
    height: 42px;
  }
}
.input-hint {
  font-size: 11px;
  color: #94a3b8;
  margin: 6px 4px 0;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 5px;
  max-width: 850px;
  margin: 10px auto;
}
.input-hint i {
  font-size: 11px;
}
.input-hint kbd {
  background: #f1f5f9;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  padding: 1px 5px;
  font-family: Outfit, sans-serif;
  font-size: 10px;
  color: #475569;
}
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.history-panel {
  position: fixed;
  top: 0;
  right: -380px;
  width: 320px;
  height: 100vh;
  background: #fff;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease;
  z-index: 1001;
  display: flex;
  flex-direction: column;
}
.history-panel.open {
  right: 0;
}
.panel-header {
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}
.panel-header h3 {
  margin: 0;
  font-size: 20px;
}
.close-btn {
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
}
.history-list {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}
.history-item {
  padding: 14px;
  border: 1px solid #eee;
  border-radius: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.history-item:hover {
  background: #f8fafc;
  transform: translateX(-3px);
}
.history-item .title {
  font-weight: 600;
  margin-bottom: 4px;
}
.history-item .date {
  font-size: 13px;
  color: #64748b;
}
@media (max-width: 768px) {
  .history-panel {
    width: 100%;
    right: -100%;
  }
  .history-panel.open {
    right: 0;
  }
  .history-btn {
    right: 16px;
    top: 16px;
  }
}
/*# sourceMappingURL=ask-questions.component.css.map */
